import { render, staticRenderFns } from "./Dashboard_TRA.vue?vue&type=template&id=52f0464a&scoped=true&"
import script from "./Dashboard_TRA.vue?vue&type=script&lang=js&"
export * from "./Dashboard_TRA.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_TRA.vue?vue&type=style&index=0&id=52f0464a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0464a",
  null
  
)

export default component.exports